import React from 'react';
import * as LuIcons from 'react-icons/lu';
import { LuTriangleAlert } from 'react-icons/lu';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  try {
    IconComponent = icon || (name && LuIcons[`Lu${name}`]);
  } catch (e) {
    IconComponent = null;
  }

  return IconComponent
    ? React.createElement(IconComponent, props)
    : <LuTriangleAlert {...props} />;
};

export default SafeIcon;